<div class="alert-content" mat-dialog-content>
    <div class="red-alert-title" i18n="Save invoice changes dialog title">Would you like to save your changes?</div>
    <p i18n="Save invoice changes dialog content">You have made changes to the invoice since you opened it. Do you want to save the changes before closing it?</p>
</div>
<mat-dialog-actions class="red-alert-actions">
    <button mat-button class="mat-primary" tabindex="-1" (click)="cancel()" i18n="Cancel button label">Cancel</button>
    <button mat-button class="mat-primary" tabindex="-1" (click)="decline()" i18n="No button label">No</button>
    <button mat-button class="mat-primary" tabindex="-1" (click)="confirm()" i18n="Yes button label">Yes</button>
</mat-dialog-actions>
